/* eslint-disable no-lone-blocks */
/* eslint-disable react/prop-types */
import {
  Typography,
  ListItemText,
  Box,
} from '@material-ui/core'
import React, { Fragment } from 'react'
import * as dayjs from 'dayjs'
import 'dayjs/locale/id'
import OrderSummary from '@components/OrderSummary'
import useStyles from './SalesOrderDetails-jss'

const tableTotal = [
  {
    name: 'formatted_subtotal',
    label: 'Subtotal',
  },
]

const CustomerData = ({ data }) => {
  const commissionTable = tableTotal.find(({ name }) => name === 'formatted_commission')
  if (data.benefit_type && data.benefit_type === 'Commission' && data.commission) {
    if (!commissionTable) {
      tableTotal.push({
        name: 'formatted_commission',
        label: 'Komisi',
      })
    }
  } else if (commissionTable) {
    tableTotal.pop()
  }
  const classes = useStyles()
  return (
    <Fragment>
      <Typography
        variant="h5"
        style={{ fontWeight: 'bold' }}
        gutterBottom
      >
        No. Penjualan <span className={classes.txNumber}>{data.transaction_id}</span>
      </Typography>
      <div className={classes.wrapper}>
        <div className={classes.customerWrapper}>
          <ListItemText
            primaryTypographyProps={{ className: classes.primaryText }}
            secondaryTypographyProps={{ className: classes.secondaryText }}
            primary="Toko"
            secondary={data?.warehouse?.name}
          />
          <ListItemText
            primaryTypographyProps={{ className: classes.primaryText }}
            secondaryTypographyProps={{ className: classes.secondaryText }}
            primary="Customer"
            secondary={data?.customer_name}
          />
          <ListItemText
            primaryTypographyProps={{ className: classes.primaryText }}
            secondaryTypographyProps={{ className: classes.secondaryText }}
            primary="No Telepon"
            secondary={data?.customer_phone}
          />
          <ListItemText
            primaryTypographyProps={{ className: classes.primaryText }}
            secondaryTypographyProps={{ className: classes.secondaryText }}
            primary="Kota"
            secondary={data?.shipping_address?.city}
          />
        </div>
        <div className={classes.customerWrapper}>
          <ListItemText
            primaryTypographyProps={{ className: classes.primaryText }}
            secondaryTypographyProps={{ className: classes.secondaryText }}
            primary="Alamat Toko"
            secondary={data?.warehouse?.city}
          />
          <ListItemText
            primaryTypographyProps={{ className: classes.primaryText }}
            secondaryTypographyProps={{ className: classes.secondaryText }}
            primary="Status"
            secondary={data?.formatted_status}
          />
          <ListItemText
            primaryTypographyProps={{ className: classes.primaryText }}
            secondaryTypographyProps={{ className: classes.secondaryText }}
            primary="Alamat"
            secondary={data?.shipping_address?.address}
          />
          <ListItemText
            primaryTypographyProps={{ className: classes.primaryText }}
            secondaryTypographyProps={{ className: classes.secondaryText }}
            primary="Kurir"
            secondary={data?.courier?.name || '-'}
          />
        </div>
      </div>
    </Fragment>
  )
}

const DetailProduct = ({ products }) => {
  const classes = useStyles()

  return (
    <Fragment>
      <Typography
        variant="h5"
        style={{ fontWeight: 'bold' }}
        gutterBottom
      >
        Detail Produk
      </Typography>
      {
        products.map(({ product, id, ...item }) => (
          <div className={classes.productWrapper} key={id}>
            <div className={classes.detailWrapper}>
              <div className={classes.imgWrapper}>
                {product.image ? (
                  <img
                    src={product.image}
                    className={classes.image}
                    alt={product.name}
                  />
                ) : <span>No Image Available</span>}
              </div>
              <div className={classes.meta}>
                <ListItemText
                  style={{ margin: 0 }}
                  primaryTypographyProps={{ className: classes.productName }}
                  primary={product.name}
                  secondary={`Kategori: ${product.category}`}
                />
                <Typography
                  variant="body1"
                  color="secondary"
                  className={classes.productPrice}
                >
                  {item.formated_price}
                </Typography>
                <Typography
                  variant="body2"
                  className={classes.txQuantity}
                >
                  Quantity : {item.quantity}
                </Typography>
                <Typography
                  variant="body2"
                  className={classes.txQuantity}
                >
                  Berat: {product.weight}
                </Typography>
                <Typography
                  variant="body2"
                  className={classes.txQuantity}
                >
                  Sub total: <span className={classes.highlightPrice}>{item.formatted_amount}</span>
                </Typography>
                <Box display="flex" flexDirection="column" className={classes.amountWrapper}>
                  {
                    item?.variants?.map((val) => (
                      <Typography
                        key={val.variant_id}
                        variant="body2"
                        className={classes.txQuantity}
                      >
                        {val?.variant_name}: {val?.variant_item?.name}
                      </Typography>
                    ))
                  }
                </Box>
              </div>
            </div>
          </div>
        ))
      }
    </Fragment>
  )
}

const SalesOrderDetail = ({ data }) => {
  const classes = useStyles()
  const summarys = {
    summary: data || {},
  }

  return (
    <div>
      <div className={classes.container}>
        <div className={classes.productWrapper}>
          {data && <CustomerData data={data} />}
          {data && <DetailProduct products={data?.order_items || []} />}
        </div>
        <div className={classes.summary}>
          <OrderSummary {...summarys} tableTotal={tableTotal} />

        </div>
      </div>
      {data
      && (
      <Box
        display="flex"
      >
        <ListItemText
          secondary={dayjs(data?.created_at).locale('id').format('DD MMMM YYYY - HH:MM')}
          primary="Dibuat"
        />
        <ListItemText
          secondary={dayjs(data?.updated_at).locale('id').format('DD MMMM YYYY - HH:MM')}
          primary="Diubah"
        />
      </Box>
      )}
    </div>
  )
}
export default SalesOrderDetail
